<template>
    <div class="table-responsive visitors-table-container">
        <table
            class="person-visitors-table table table-sm table-bordered table-hover"
        >
            <caption>
                Ingresos de Personas
            </caption>
            <thead class="thead-orange">
                <tr>
                    <th>Visitante</th>
                    <th>Documento Visitante</th>
                    <th>Tipo de visitante</th>
                    <th>Salio (si/no)</th>
                    <th>Minutos Visita</th>
                    <th>Registrado en</th>
                    <th>Destino</th>
                    <th>Persona Visitada</th>
                    <th>Es Visitante</th>
                    <!-- <th>Motivo</th> -->
                    <th>Notas</th>
                    <th>Registrado por</th>
                    <th>Temp</th>
                    <th>Bioseguridad</th>
                    <th>Fecha Ingreso</th>
                    <th>Fecha Salida</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="entry in data"
                    :key="entry.id"
                    :data-entry="entry.id"
                    :id="`entry_${entry.id}`"
                    class="entry-row"
                    :data-image="
                        !!entry.person && !!entry.person.photo
                            ? entry.person.photo
                            : ''
                    "
                    :data-person="entry.person.name"
                >
                    <td :id="`name-${entry.id}`">{{ entry.person.name }}</td>
                    <td>{{ entry.person.document }}</td>
                    <td>{{ entry.visitor_type.name }}</td>
                    <td>{{ entry.completed | yesno }}</td>
                    <td>{{ entry.duration }}</td>
                    <td>{{ entry.structure.name }}</td>
                    <td>{{ entry.destination.name }}</td>
                    <td>
                        {{
                            !!entry.visited_person
                                ? entry.visited_person.name
                                : ''
                        }}
                    </td>
                    <td>{{ !entry.person.internal | yesno }}</td>
                    <!-- <td>{{ entry.purpose }}</td> -->
                    <td>{{ entry.notes }}</td>
                    <td>{{ entry.user.name }}</td>
                    <td>{{ entry.temperature }}</td>
                    <td>{{ getBioprotection(entry.bioprotection) }}</td>
                    <td>{{ entry.created_at | datetime }}</td>
                    <td v-if="entry.departure">
                        {{ entry.departure.created_at | datetime }}
                    </td>
                    <td v-else></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    props: {
        data: {
            type: Array,
            required: true,
        },
    },
    watch: {
        data(value) {
            this.$nextTick(() => {
                this.createPopOvers()
            })
        },
    },
    methods: {
        createPopOvers() {
            $('.entry-row').each(function() {
                const row = $(this)
                if (!row.data('image')) return
                row.popover({
                    placement: 'top',
                    content:
                        '<img src="' +
                        row.data('image') +
                        '" style="max-width: 100%;" />',
                    html: true,
                    title: row.data('person') || '',
                    trigger: 'hover',
                    container: $(`#name-${row.data('entry')}`)[0],
                })
            })
        },
        getBioprotection(val) {
            return val === null ? '' : val === 1 ? 'SI' : 'NO'
        },
    },
    mounted() {
        this.createPopOvers()
    },
}
</script>
<style>
.visitors-table-container {
    /* max-width: 70%; */
}
body {
    overflow-x: hidden;
}
</style>
